#@export GliveBooking.Presenters.QuantityPicker

class GliveBooking.Presenters.QuantityPicker extends BookingV2.Presenters.Picker

  module: 'glive-booking'

  toHash: ->
    hash = BookingV2.Presenters.Picker.prototype.toHash.apply(this, arguments)
    if @selected()?
      hash.selectedQuantity =
        quantity: @selected().getPartySize()
    hash.isTouch = @collection.meta('isTouch')
    hash
